import { render, staticRenderFns } from "./MaConfiguration.vue?vue&type=template&id=93dfdf80"
import script from "./MaConfiguration.vue?vue&type=script&lang=js"
export * from "./MaConfiguration.vue?vue&type=script&lang=js"
import style0 from "./MaConfiguration.vue?vue&type=style&index=0&id=93dfdf80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports